import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { isAdminRoute } from './is-admin-route';
import { loadTarteaucitronScript } from './load-tarteaucitron-script';
import {
  GOOGLE_TAG_MANAGER_JOB,
  GTM_ACCOUNT_ID,
  TARTEAUCITRON_INIT_OPTIONS,
} from './tarteaucitron.config';
import { TarteaucitronGlobal } from './tarteaucitron.types';

const ICON_ELEMENT_ID = 'tarteaucitronIcon';

function setIconHidden(hidden: boolean): void {
  const icon = document.getElementById(ICON_ELEMENT_ID);
  if (icon) icon.style.display = hidden ? 'none' : '';
}

function initializeTarteaucitron(tarteaucitron: TarteaucitronGlobal): void {
  tarteaucitron.init(TARTEAUCITRON_INIT_OPTIONS);
  tarteaucitron.user.googletagmanagerId = GTM_ACCOUNT_ID;
  tarteaucitron.job = tarteaucitron.job || [];
  tarteaucitron.job.push(GOOGLE_TAG_MANAGER_JOB);
}

export function useTarteaucitron(): void {
  const { pathname } = useLocation();
  const initializedRef = useRef(false);

  useEffect(() => {
    // Read the live path: by the time async work settles the user may have navigated.
    const applyIconVisibility = () => setIconHidden(isAdminRoute(window.location.pathname));
    const onAdminRoute = isAdminRoute(pathname);

    if (!initializedRef.current) {
      if (onAdminRoute) return;
      initializedRef.current = true;
      loadTarteaucitronScript()
        .then((tarteaucitron) => {
          initializeTarteaucitron(tarteaucitron);
          applyIconVisibility();
          // tarteaucitron defers building the icon to the window 'load' event when
          // the document is not yet "complete"; re-apply once the icon exists.
          window.addEventListener('load', applyIconVisibility, { once: true });
        })
        .catch((error) => {
          initializedRef.current = false;
          // eslint-disable-next-line no-console
          console.error('Failed to initialize tarteaucitron', error);
        });
      return;
    }

    applyIconVisibility();
  }, [pathname]);
}
